<template>
  <div class="loader">
    <LoaderBalls />
  </div>
</template>

<script>
import LoaderBalls from '@/base/components/Loaders/LoaderBalls.vue'

export default {
  name: 'Loader',
  components: { LoaderBalls }
}
</script>
